<div class="description-sensor" *ngIf="sensors">
  <div class="header-details">
    <div class="row">
      <div class="button" (click)="onBackButtonClicked()" *ngIf="showBackButton"><span class="fa fa-chevron-left"></span></div>
      <div class="title">IOT Sensoren</div>
    </div>
    <div class="sensors-details">
      <div class="address-details">
        <label class="address-label">Adresse</label>
        <label class="address">{{ sensorAddress }}</label>
      </div>
      <div class="gps-details">
        <label class="gps-label">GPS Standort</label>
        <div class="gps">
          <label class="-label"
            >BREITE<span class="value bold">{{ sensors[0].latlang[0] | localNumber }}</span></label
          >
          <label class="-label"
            >LÄNGE<span class="value bold">{{ sensors[0].latlang[1] | localNumber }}</span></label
          >
        </div>
      </div>
    </div>
  </div>
  <div class="sensors">
    <app-sensor-list [sensors]="sensorList"></app-sensor-list>
  </div>
</div>
